export default "/images/vendor/flag-icon-css/flags/4x3/so.svg?d1a7d3e18523bf69f2eb0470b89b7622";